import { Link } from "react-router";

const LEVELS = ["n5", "n4", "n3", "n2", "n1"] as const;

type LevelSlug = (typeof LEVELS)[number];

export function LevelSelector({ active }: { active: LevelSlug }) {
  return (
    <nav className="flex items-center gap-1.5">
      {LEVELS.map((level) => {
        const selected = active === level;
        return (
          <Link
            key={level}
            to={`/atlas/${level}`}
            aria-current={selected ? "page" : undefined}
            className="n5-btn"
            data-variant={selected ? "known" : undefined}
          >
            {level.toUpperCase()}
          </Link>
        );
      })}
    </nav>
  );
}
